import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ListLikesComponent } from './list-likes.component';
import { PAGES_AND_PATHS } from 'src/app/constants/pages-and-paths';
import { AuthGuardService } from 'src/app/guards/auth-guard.service';

const routes: Routes = [
  {
    path: PAGES_AND_PATHS.listLikes.pageInRouting,
    data: { data: PAGES_AND_PATHS.listLikes },
    component: ListLikesComponent,
    canActivate: [AuthGuardService],
    loadChildren: () => import('./list-likes.module').then(m => m.ListLikesModule)
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class ListLikesRoutingModule { }
